import React, { useState } from 'react';
import { Globe } from 'lucide-react';
import { LegalModal } from './LegalModal';
import { useLanguage } from '../contexts/LanguageContext';
type ModalType = 'terms' | 'privacy' | null;
export function Footer() {
  const [openModal, setOpenModal] = useState<ModalType>(null);
  const {
    setLang,
    t
  } = useLanguage();
  const handleChangeLanguage = () => {
    try {
      window.localStorage.removeItem('rs_lang');
    } catch (e) {}
    window.location.reload();
  };
  return <>
      <footer className="w-full bg-[#3E2723] border-t border-white/10 py-10" data-id="element-245">
        <div className="max-w-7xl mx-auto px-6 md:px-12 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-246">
          <p className="text-white/70 text-sm text-center md:text-left" data-id="element-247">
            © {new Date().getFullYear()} {t('footer.rights')}
          </p>
          <nav className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3" data-id="element-248">
            <button onClick={() => setOpenModal('terms')} className="text-white/80 hover:text-white text-sm font-medium transition-colors underline-offset-4 hover:underline" data-id="element-249">
              {t('footer.terms')}
            </button>
            <button onClick={() => setOpenModal('privacy')} className="text-white/80 hover:text-white text-sm font-medium transition-colors underline-offset-4 hover:underline" data-id="element-250">
              {t('footer.privacy')}
            </button>
            <button onClick={handleChangeLanguage} className="inline-flex items-center gap-1.5 text-white/80 hover:text-white text-sm font-medium transition-colors underline-offset-4 hover:underline" data-id="element-251">
              <Globe className="w-4 h-4" data-id="element-252" />
              {t('footer.changeLang')}
            </button>
          </nav>
        </div>
      </footer>

      <LegalModal isOpen={openModal === 'terms'} onClose={() => setOpenModal(null)} title={t('footer.termsContent.title')} data-id="element-253">
        <p className="text-sm text-[#3E2723]/60" data-id="element-254">
          {t('footer.termsContent.lastUpdated')}{' '}
          {new Date().toLocaleDateString('en-US', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        })}
        </p>

        <h3 className="text-xl font-semibold text-[#3E2723] mt-4" data-id="element-255">
          {t('footer.termsContent.h1')}
        </h3>
        <p data-id="element-256">{t('footer.termsContent.p1')}</p>

        <h3 className="text-xl font-semibold text-[#3E2723] mt-4" data-id="element-257">
          {t('footer.termsContent.h2')}
        </h3>
        <p data-id="element-258">{t('footer.termsContent.p2')}</p>

        <h3 className="text-xl font-semibold text-[#3E2723] mt-4" data-id="element-259">
          {t('footer.termsContent.h3')}
        </h3>
        <p data-id="element-260">{t('footer.termsContent.p3')}</p>

        <h3 className="text-xl font-semibold text-[#3E2723] mt-4" data-id="element-261">
          {t('footer.termsContent.h4')}
        </h3>
        <p data-id="element-262">{t('footer.termsContent.p4')}</p>

        <h3 className="text-xl font-semibold text-[#3E2723] mt-4" data-id="element-263">
          {t('footer.termsContent.h5')}
        </h3>
        <p data-id="element-264">{t('footer.termsContent.p5')}</p>

        <h3 className="text-xl font-semibold text-[#3E2723] mt-4" data-id="element-265">
          {t('footer.termsContent.h6')}
        </h3>
        <p data-id="element-266">{t('footer.termsContent.p6')}</p>

        <h3 className="text-xl font-semibold text-[#3E2723] mt-4" data-id="element-267">
          {t('footer.termsContent.h7')}
        </h3>
        <p data-id="element-268">{t('footer.termsContent.p7')}</p>
      </LegalModal>

      <LegalModal isOpen={openModal === 'privacy'} onClose={() => setOpenModal(null)} title={t('footer.privacyContent.title')} data-id="element-269">
        <p className="text-sm text-[#3E2723]/60" data-id="element-270">
          {t('footer.termsContent.lastUpdated')}{' '}
          {new Date().toLocaleDateString('en-US', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        })}
        </p>

        <h3 className="text-xl font-semibold text-[#3E2723] mt-4" data-id="element-271">
          {t('footer.privacyContent.h1')}
        </h3>
        <p data-id="element-272">{t('footer.privacyContent.p1')}</p>

        <h3 className="text-xl font-semibold text-[#3E2723] mt-4" data-id="element-273">
          {t('footer.privacyContent.h2')}
        </h3>
        <p data-id="element-274">{t('footer.privacyContent.p2')}</p>
        <ul className="list-disc pl-6 space-y-1" data-id="element-275">
          <li data-id="element-276">{t('footer.privacyContent.l2a')}</li>
          <li data-id="element-277">{t('footer.privacyContent.l2b')}</li>
          <li data-id="element-278">{t('footer.privacyContent.l2c')}</li>
        </ul>

        <h3 className="text-xl font-semibold text-[#3E2723] mt-4" data-id="element-279">
          {t('footer.privacyContent.h3')}
        </h3>
        <p data-id="element-280">{t('footer.privacyContent.p3')}</p>

        <h3 className="text-xl font-semibold text-[#3E2723] mt-4" data-id="element-281">
          {t('footer.privacyContent.h4')}
        </h3>
        <p data-id="element-282">{t('footer.privacyContent.p4')}</p>

        <h3 className="text-xl font-semibold text-[#3E2723] mt-4" data-id="element-283">
          {t('footer.privacyContent.h5')}
        </h3>
        <p data-id="element-284">{t('footer.privacyContent.p5')}</p>

        <h3 className="text-xl font-semibold text-[#3E2723] mt-4" data-id="element-285">
          {t('footer.privacyContent.h6')}
        </h3>
        <p data-id="element-286">{t('footer.privacyContent.p6')}</p>

        <h3 className="text-xl font-semibold text-[#3E2723] mt-4" data-id="element-287">
          {t('footer.privacyContent.h7')}
        </h3>
        <p data-id="element-288">{t('footer.privacyContent.p7')}</p>

        <h3 className="text-xl font-semibold text-[#3E2723] mt-4" data-id="element-289">
          {t('footer.privacyContent.h8')}
        </h3>
        <p data-id="element-290">{t('footer.privacyContent.p8')}</p>
      </LegalModal>
    </>;
}